import { formatLongDate } from '@/lib/format-long-date';
import type { SuccessFeeTermsDocument, SuccessFeeTermsState } from '@fluenceur/types';
import { Button, Flex, Text } from '@chakra-ui/react';
import { Alert } from '@fluenceur/ui';
import type React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SuccessFeeTermsDialog } from './SuccessFeeTermsDialog';

export interface TermsAcceptanceNoticeProps {
  state: SuccessFeeTermsState;
  document: SuccessFeeTermsDocument | null;
}

/**
 * The first of the two steps: reading the terms and accepting them.
 *
 * The action differs by right, the sentence does not: a member with view access
 * has to be able to tell an administrator, so it is shown the same deadline.
 */
export const TermsAcceptanceNotice: React.FC<TermsAcceptanceNoticeProps> = ({
  state,
  document,
}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const deadline = formatLongDate(state.deadline, t('common.locale'));
  const canAccept = state.canAccept;

  return (
    <>
      <Alert
        size="sm"
        status="warning"
        py={2}
        borderRadius="0"
        justifyContent="center"
        fontSize="13px"
      >
        <Flex align="center" gap={2} gapX={4} justifyContent="center" wrap="wrap">
          <Text>
            {deadline
              ? t('legal.successFeeTerms.banner.message', { date: deadline })
              : t('legal.successFeeTerms.banner.messageWithoutDate')}
          </Text>
          <Button onClick={() => setIsDialogOpen(true)} variant="solid" size="xs">
            {canAccept
              ? t('legal.successFeeTerms.banner.action')
              : t('legal.successFeeTerms.banner.readAction')}
          </Button>
        </Flex>
      </Alert>

      <SuccessFeeTermsDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        document={document}
        canAccept={canAccept}
      />
    </>
  );
};
